import { BoxedRow, BoxedRowList, Row, RowList, Switch } from '@telefonica/mistica';
import React from 'react';
import './index.scss';

export type ICardSwitch = {
    index: string;
    title: string;
    subtitle: string;
    state: boolean;
    onHandleSwicth: (ev: ICardSwitchEvent) => any;
    icon?: JSX.Element;
    headline?: JSX.Element;
    boxed?: boolean;
};

export type ICardSwitchEvent = {
    index: string;
    state: boolean;
};

export const CardWithSwitch: React.FC<ICardSwitch> = ({
    index,
    title,
    subtitle,
    state = false,
    onHandleSwicth,
    icon,
    headline,
    boxed = false,
}) => {
    const onChange = (state: boolean) => {
        return onHandleSwicth({ state, index });
    };

    const RowListComponent = boxed ? BoxedRowList : RowList;
    const RowComponent = boxed ? BoxedRow : Row;

    return (
        <RowListComponent>
            <RowComponent
                asset={icon}
                headline={headline}
                title={title}
                description={subtitle}
                right={
                    <div className='cardWithSwitch-component'>
                        <Switch name={`switch-${index}`} checked={state} onChange={onChange}></Switch>
                    </div>
                }
            />
        </RowListComponent>
    );
};
export default CardWithSwitch;
